import { createResourceQuery } from './factory'

type Props = { enabled?: boolean }

export const useAccessibleOrganizations = createResourceQuery<'accessible_organizations', Props>({
   queryKey: 'accessible-organizations',
   view: 'accessible_organizations',
   order: [
      { column: 'group_name', ascending: true },
      { column: 'organization_name', ascending: true },
   ],
})
